// src/components/Services.js
import React from 'react';
import './Services.css';

function Services() {
  return (
    <section className="services" id="services">
      <div className="services-container">
        <h2>SERVICES</h2>
        <p className="services-subtitle">What we offer</p>
        
        <div className="services-grid">
          <div className="service-card">
            <h3>SOFTWARE DEVELOPMENT</h3>
            <p>Custom solutions tailored to your business needs using cutting-edge technology.</p>
          </div>
          <div className="service-card">
            <h3>DATA ANALYSIS</h3>
            <p>Transform your data into actionable insights with advanced analytics and visualization.</p>
          </div>
          <div className="service-card">
            <h3>AI SOLUTIONS</h3>
            <p>Harness the power of artificial intelligence to automate and optimize your processes.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;